import { render } from "./mobile-menu-link.vue?vue&type=template&id=b7a44f3e"
import script from "./mobile-menu-link.vue?vue&type=script&lang=js"
export * from "./mobile-menu-link.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__